import { DateInput, DateValue } from '@mantine/dates'
import AppIcon from '../common/AppIcon'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import AppInputWrapper from './AppInputWrapper'
import { useEffect, useState } from 'react'
import { useDebouncedCallback } from '@mantine/hooks'

interface CustomProps extends React.ComponentPropsWithoutRef<typeof DateInput> {
  name?: string
  value?: DateValue | undefined
  onChange?: any
  w?: string | number
  label?: string
  labelh?: string
  placeholder?: string
  debounced?: boolean
}

const AppDateInput = ({
  name,
  value,
  onChange,
  w = 150,
  label,
  labelh,
  placeholder,
  debounced = true,
  ...otherProps
}: CustomProps) => {
  const { t } = useTranslation()
  const [localValue, setLocalValue] = useState<DateValue | undefined>(
    value ? new Date(value) : undefined,
  )

  useEffect(() => {
    setLocalValue(value ? new Date(value) : undefined)
  }, [value])

  const debouncedOnChange = useDebouncedCallback(
    (v: string | null) => {
      onChange?.(name ? { target: { name, value: v } } : v)
    },
    300, // milisegundos de debounce
  )
  return (
    <AppInputWrapper w={w} label={label}>
      {labelh && t(labelh)}
      <DateInput
        {...otherProps}
        miw={150}
        w={w}
        label={label && t(label)}
        value={dayjs(localValue).toDate()}
        onChange={(_value: Date | null) => {
          const formattedDate = _value ? dayjs(_value).toISOString() : null
          setLocalValue(_value)
          if (onChange) {
            if (debounced) debouncedOnChange(formattedDate)
            else onChange(formattedDate)
          }
        }}
        valueFormat="DD/MM/YYYY"
        leftSection={<AppIcon icon="calendar" />}
        locale="es"
      />
    </AppInputWrapper>
  )
}

export default AppDateInput
